import type { XhrRequestMeta } from 'src/typescript/interfaces/XhrRequestMeta';

const EVENTS_BASE_URL = '/events/message';

export interface ExportResponse {
  created_at: string;
  error?: string;
  file_url?: string;
  finished_at?: string;
  format: 'csv';
  id: string;
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
}

export function getMessageEvents(params: object): XhrRequestMeta {
  return {
    method: 'GET',
    url: `/v1${EVENTS_BASE_URL}`,
    params
  };
}

export const createMessageEventsExport = (params: object): XhrRequestMeta => ({
  url: `/v1${EVENTS_BASE_URL}/exports`,
  method: 'POST',
  data: params
});

export const getMessageEventsExport = (exportId: string): XhrRequestMeta => ({
  url: `/v1${EVENTS_BASE_URL}/exports/${exportId}`,
  method: 'GET'
});
